import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import {
  CATERING_FULFILLMENT_METHOD_PROPTYPES,
  CATERING_FULFILLMENT_OPTIONS_PROPTYPES
} from 'propTypes';

import { AppBarIcon } from 'components/AppBar';
import IconTextButton from 'catering/components/Menu/MenuAppBar/IconTextButton';

import {
  ALL_CATERING_FULFILLMENT_METHODS,
  fulfillmentOptions
} from 'constants/fulfillmentOptions';
import { getHeaderLinkMainMediumColor } from 'styles/helpers/getThemeStyles';
import { useIsDesktop } from 'styles/hooks/mediaQueries';
import { toTitleCase } from 'bento-ordering/base/utils/textUtils';

const optionOverridesSx = theme => ({
  '&.MuiButton-text': {
    textTransform: 'capitalize',
    [theme.breakpoints.down('md')]: {
      textTransform: 'uppercase'
    }
  },
  '& .MuiButton-iconSizeLarge': {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
});

function FulfillmentOptions({
  activeFulfilmentMethod,
  availableFulfillmentOptions,
  onFulfillmentOptionClick
}) {
  const isDesktop = useIsDesktop();

  const [
    displayDeliveryOption,
    displayPickupOption
  ] = ALL_CATERING_FULFILLMENT_METHODS.map(fulfillmentMethod => {
    const isMethodAvailable = !!availableFulfillmentOptions.find(
      fulfillmentOption => fulfillmentMethod === fulfillmentOption
    );
    const isActiveMethod = activeFulfilmentMethod === fulfillmentMethod;
    return !isDesktop ? isActiveMethod : isMethodAvailable;
  });

  const isDeliveryActive =
    activeFulfilmentMethod === fulfillmentOptions.DELIVERY;
  const isPickupActive = activeFulfilmentMethod === fulfillmentOptions.PICKUP;

  const ownDeliveryLabelState = theme => {
    const useDeliveryLabelStyles = !isDeliveryActive;
    let styles = {};
    if (useDeliveryLabelStyles) {
      styles = {
        color: getHeaderLinkMainMediumColor(theme)
      };
    }
    return styles;
  };

  const ownPickupLabelState = theme => {
    const usePickupLabelStyles = !isPickupActive;
    let styles = {};
    if (usePickupLabelStyles) {
      styles = {
        color: getHeaderLinkMainMediumColor(theme)
      };
    }
    return styles;
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      {displayDeliveryOption && (
        <IconTextButton
          sx={optionOverridesSx}
          isActive={isDeliveryActive}
          label={toTitleCase(fulfillmentOptions.DELIVERY)}
          onClick={() => onFulfillmentOptionClick(fulfillmentOptions.DELIVERY)}
          startIcon={<AppBarIcon icon={fulfillmentOptions.DELIVERY} />}
          ownState={{
            label: ownDeliveryLabelState
          }}
        />
      )}

      {displayPickupOption && (
        <IconTextButton
          sx={optionOverridesSx}
          isActive={isPickupActive}
          label={toTitleCase(fulfillmentOptions.PICKUP)}
          onClick={() => onFulfillmentOptionClick(fulfillmentOptions.PICKUP)}
          startIcon={<AppBarIcon icon={fulfillmentOptions.PICKUP} />}
          ownState={{
            label: ownPickupLabelState
          }}
        />
      )}
    </Box>
  );
}

FulfillmentOptions.propTypes = {
  activeFulfilmentMethod: CATERING_FULFILLMENT_METHOD_PROPTYPES.isRequired,
  availableFulfillmentOptions:
    CATERING_FULFILLMENT_OPTIONS_PROPTYPES.isRequired,
  onFulfillmentOptionClick: PropTypes.func.isRequired
};

export default FulfillmentOptions;
